<card-component>
	<card-content>
		@if (tableEntities) {
			<cdk-table-component
				[displayColumns]="displayColumns"
				[entities]="tableEntities"
				[dataSource]="dataSource"
			></cdk-table-component>
		}
	</card-content>
</card-component>
